import { AthenaTicketStatusEnums, AthenaTicketStatusWithPrefix, athenaTicketStatusSettings, TicketStatusPrefix } from '@/types/transaction-setting'

const getTicketSetting = (status: AthenaTicketStatusEnums) => athenaTicketStatusSettings[status];

interface getDisplayAmountProps {
	currencyName?: string;
	amount: number;
	enableCurrencyDisplay?: boolean;
	currencySymbol?: string;
}
const getDisplayAmount = ({
	currencyName,
	amount,
	enableCurrencyDisplay,
	currencySymbol = '$'
}: getDisplayAmountProps) => `${currencySymbol}${enableCurrencyDisplay ? `${currencyName} ` : ''}${amount.toString().replace(/^(-?\d+)((\.\d*)?)$/, (_s, s1, s2) => s1.replace(/\d{1,3}(?=(\d{3})+$)/g, '$&,') + ((s2 == '') ? '.00' : s2))}`

const parseTicketStatus = (status: AthenaTicketStatusWithPrefix): AthenaTicketStatusEnums => Number(status.replace(TicketStatusPrefix, ''));

export const transactionService = {
	getTicketSetting: getTicketSetting,
	getDisplayAmount: getDisplayAmount,
	parseTicketStatus: parseTicketStatus
}